import * as config from "../config";
import moment from 'moment-timezone';


export function GetDataFile(dir, id) {
    if (dir === 'argos') {
        return `${config.S3_URL}/${dir}/${id}/data2.js`;
    }
    return `${config.S3_URL}/${dir}/${id}/data.js`;
}

export function GetProductsFile(dir, id) {
    if (dir === 'argos') {
        return `${config.S3_URL}/${dir}/${id}/products.js`;
    }
    if (dir === 'demo') {
        return `${config.S3_URL}/demo/${id}/products.js`;
    }
    return `${config.S3_URL}/${dir}/${id}/products.js`;
}

export function GetVideoFile(dir, id) {
    if (dir === 'argos') {
        return `${config.S3_URL}/${dir}/${id}/video.mp4`;
    }
    if (dir === 'demo') {
        return `${config.S3_URL}/demo/${id}/media/hls/master.m3u8`;
    }
    return `${config.S3_URL}/${dir}/${id}/video.mp4`;
}

export function GetCurrency(currency) {
    // console.log(currency, " currency")
    if (currency === 'tl') {
        return "₺";
    }
    if (currency === 'pound') {
        return "£"
    }
    if (currency === 'dollar') {
        return "$"
    }
    if (currency === 'euro') {
        return "€"
    }
    return "£";
}

export function SendAction(partner, videoId, action, product) {

    const format = "DD/MM/YYYY HH:mm:ss"
    const today = new Date();

    const date = moment(today).format(format);
    const timezone = moment.tz.guess();
    const userId = localStorage.getItem("userId")
    const userAgent = navigator.userAgent

    const requestOptions = {
    mode: 'no-cors',
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true'},
    body: JSON.stringify({
        "userId": userId,
        "userAgent": userAgent,
        "partner": partner,
        "videoId": videoId,
        "date_time": date,
        "timezone": timezone,
        "action": action,
        "productId": product
    })
};
fetch('https://6euxm4gzn7.execute-api.eu-west-2.amazonaws.com/Endpoints/insert', requestOptions)
    .then(data => console.log(data, " response"));

}

export const Actions = {
    Start: 'start',
    Play: 'play',
    Pause: 'pause',
    End: 'end',
    Left: 'Left',
    Right: 'Right'
};
